import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { RichText } from "../components/richtext/richtext"
import { SLSlider } from "../components/slider/slider"
import { Map } from "../components/map"
import countyStyles from "./county.module.css"

type jsonText = { json: object }
type mapType = { map: any }

export default function ContentPageTemplate(props: {
  pageContext: {
    mainContent?: jsonText
    asideText?: jsonText
    title: string
    secondaryContent?: jsonText
    slider?: any
    images?: Array<any>
    images2?: Array<any>
    mapAside?: mapType
  }
}) {
  const {
    mainContent,
    asideText,
    title,
    secondaryContent,
    slider,
    mapAside,
  } = props.pageContext
  return (
    <Layout>
      <SEO title={title} />
      <div>
        <div className={countyStyles.content}>
          <main style={{ minWidth: "60%" }}>
            {RichText(mainContent)}
            {slider && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                  style={{
                    maxWidth: "300px",
                    marginTop: "1em",
                    marginBottom: "1em",
                  }}
                >
                  <SLSlider images={slider.images} />
                </div>
              </div>
            )}
          </main>
          {asideText && asideText.json && (
            <aside
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
              className={countyStyles.aside}
            >
              {RichText(asideText)}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Map>{mapAside.map}</Map>
              </div>
            </aside>
          )}
        </div>

        {secondaryContent && secondaryContent.json && (
          <div>{RichText(secondaryContent)}</div>
        )}
      </div>
    </Layout>
  )
}
